<a
  [href]="href"
  [ngClass]="btnCss"
  [attr.data-e2e]="e2eId"
  [target]="target"
  *ngIf="text"
>
  <nibtravel-icon
    *ngIf="icon"
    [icon]="icon"
    spacing="space-right"
  ></nibtravel-icon>
  {{ text }}
</a>
